import React from 'react';
import PropTypes from 'prop-types';

import DsLabel from '../label';
import Btn from './index';

const BtnSave = ({ label, className, onClick }, context) => {
  const getLabel = label || context.t('Save');
  return (
    <Btn onClick={onClick} className={`${className || ''} fles justify-center items-center`}>
        <DsLabel icon="check" className="text-status-green capitalize font-bold" iconClassName="text-lg">
          {getLabel}
        </DsLabel>
    </Btn>);
};

BtnSave.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

BtnSave.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BtnSave;
